<template>
    <v-hover v-slot:default="{ hover }">
      <v-card
        tile
        :color="getBackgroundColor(hover)"
        style="border-radius: 0px !important"
        class="my-1 pa-0"
        :elevation="hover ? 4 : 1"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
      >
        <v-card-text class="pa-1" style="font-size: 14px">
          <DocumentItemToolbar
            :v-if="!document.isDeleted"
            :documentId="document.id"
            :permissions="document.permissions"
            :commentsCount="document.totalComments"
            :attachmentsCount="document.totalAttachments"
            :alertsCount="document.totalAlerts"
            :linkedDocumentsCount="document.totalLinkedDocuments"
            :canUnblock="document.canUnblock"
            :isBlocked="document.isBlocked"
            :lockInfo="document.lockInfo"
            :isDistributed="document.isDistributed"
            :isInWorkflow="document.isInWorkflow"
            :isPendingConfirmation="document.isPendingConfirmation"
            :isLastVersion="document.isLastVersion"
            :hasPlugins="document.hasPlugins"
            :isPdf="document.extension.toLowerCase() == '.pdf'"
            :lockType="document.documentDeferredProcessType"
            :currentUserHasValidatedDocument="document.currentUserHasValidatedDocument"
            :totalValidationsCount="document.totalFlowValidations"
            @on-document-removed="onDocumentRemoved"
            @on-version-removed="onVersionRemoved"
            @on-document-blocked="onDocumentBlocked"
            @on-reception-confirmed="onReceptionConfirmed"
            @on-selection-change="onSelectionChange"
            @on-action-click="onActionClick"
            @on-edit-click="onEditClick"
            @on-flow-diagram-click="onFlowDiagramClick"
            @on-sign-click="onSignClick"
            @on-load-plugin-click="onloadPluginClick"
            @on-retry-process="onRetryProcess"
            :selectedDocuments="selectedDocuments"
          />

          <CommentList
            v-if="showComments"
            :permissions="document.permissions"
            :documentId="document.id"
            @on-close-click="onActionClick('comment')"
            @on-comments-updated="onCommentsUpdated"
          />

          <AlertList
            v-if="showAlerts"
            :documentId="document.id"
            @on-close-click="onActionClick('alert')"
            @on-alert-updated="onAlertUpdated"
          />

          <LinkedDocumentsList
            v-if="showLinkedDocuments"
            :documentId="document.id"
            @on-close-click="onActionClick('linkedDocuments')"
            @on-linked-documents-updated="onLinkedDocumentsUpdated"
          />

          <VersionList
            v-if="showVersions"
            :documentId="document.id"
            @on-close-click="onActionClick('version')"
            @on-version-click="onVersionClick"
          />

          <HistoryList
            v-if="showHistory"
            :documentId="document.id"
            @on-close-click="onActionClick('history')"
          />

          <AttachmentList
            v-if="showAttachments"
            :permissions="document.permissions"
            :documentId="document.id"
            :contentTypeId="document.contentTypeID"
            @on-close-click="onActionClick('attachment')"
            @on-attachment-updated="onAttachmentsUpdated"
          />

          <DistributionList
            v-if="showDistributions"
            :documentId="document.id"
            @on-close-click="onActionClick('distribution')"
            @on-distribution-ended="onDistributionEnded"
          />

          <SignatureList
            v-if="showSignatures"
            :documentId="document.id"
            @on-close-click="onActionClick('signatures')"
          />

          <DocumentItemFields
            :fieldList="getFields"
            :documentId="document.id"
            @on-fields-click="onFieldsClick"
          />

          <!-- <template v-if="fieldExpanded">
            <div v-for="group in document.groups" v-bind:key="group.name">
              <span class="font-weight-bold ma-1 text-uppercase">{{group.name}}</span>
              <document-item-fields :fieldList="group.fields" :documentId="document.id" />
            </div>
          </template> -->
          <DocumentItemFooter
            :documentVersion="document.version"
            :contentType="document.contentType"
            :fileExtension="document.extension"
            :isLastVersion="document.isLastVersion"
            :isDigitallySigned="document.isDigitallySigned"
            :isPdf="document.extension.toLowerCase() == '.pdf'"
            @on-action-click="onActionClick"
          />
        </v-card-text>
      </v-card>
    </v-hover>
  </template>

  <script>
import DocumentItemFooter from '@/components/search/results/list/item/DocumentItemFooter';
import DocumentItemToolbar from '@/components/search/results/list/item/DocumentItemToolbar';
import DocumentItemFields from '@/components/search/results/list/item/DocumentItemFields';
import CommentList from '@/components/search/results/list/item/actions/comment/CommentList';
import VersionList from '@/components/search/results/list/item/actions/version/VersionList';
import HistoryList from '@/components/search/results/list/item/actions/history/HistoryList';
import AlertList from '@/components/search/results/list/item/actions/alert/AlertList';
import AttachmentList from '@/components/search/results/list/item/actions/attachment/AttachmentList';
import DistributionList from '@/components/search/results/list/item/actions/distribution/DistributionList';
import SignatureList from '@/components/search/results/list/item/actions/signature/SignatureList';
import LinkedDocumentsList from '@/components/search/results/list/item/actions/link/LinkedDocumentsList';
import DocumentItemMixin from '@/mixins/SearchResultsView/DocumentItemMixin';

export default {
    components: {
        DocumentItemFooter,
        DocumentItemToolbar,
        DocumentItemFields,
        CommentList,
        VersionList,
        HistoryList,
        AlertList,
        AttachmentList,
        DistributionList,
        SignatureList,
        LinkedDocumentsList,
    },
    mixins: [DocumentItemMixin]
};
  </script>
